import axios from "../utils/axios";

export const postCheckItemGroupPlannedExcelToList = (payload) => {
    return axios.post(`/PlannedCheckItemGroup/excel/toList`, payload);
};

export const postCheckItemGroupPlannedExcelUpload = (payload) => {
    return axios.post(`/PlannedCheckItemGroup/excel?fileCheckSum=${payload}`);
};

export const downloadCheckItemGroupPlannedExcel = () => {
    return axios.get(`/PlannedCheckItemGroup/excel/template`, {
        responseType: "blob",
    });
};

export const postCheckItemGroupAutonomousExcelToList = (payload) => {
    return axios.post(`/AutonomousCheckItemGroup/excel/toList`, payload);
};

export const postCheckItemGroupAutonomousExcelUpload = (payload) => {
    return axios.post(`/AutonomousCheckItemGroup/excel?fileCheckSum=${payload}`);
};

export const downloadCheckItemGroupAutonomousExcel = () => {
    return axios.get(`/AutonomousCheckItemGroup/excel/template`, {
        responseType: "blob",
    });
};